import {getAuth, signInWithEmailAndPassword} from 'firebase/auth';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

/**
 * Sign in page
 * @returns 
 */
export default function SignIn() {
	// Initialize Firebase Authentication and get a reference to the service
	const auth = getAuth();
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [errorMessage, setErrorMessage] = useState('')
	const handleSignIn = event => {
		event.preventDefault();
		console.log('signined');
		signInWithEmailAndPassword(auth, email, password)
			.then(userCredential => {
				//Signed in
				const user = userCredential.user;
				console.log(user);
				navigate('/admin', {replace: true});
				//
			})
			.catch(error => {
				const errorCode = error.code;
				const errorMessage = error.message;
				console.log(errorCode, errorMessage);
				if (errorCode === 'auth/invalid-credential') {
					setErrorMessage('Invalid credentials.')
				}
			});
	};

	return (
		<>
			{/** TODO Make some CSS classes and pretty this up, taller inputs, more styling */}
			<main style={{display: 'flex'}}>
				<section
					style={{
						flex: 1,
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<form
						onSubmit={handleSignIn}
						className="signInBox"
						style={{display: 'flex', flexDirection: 'column', margin: '0 auto'}}
					>
						<label htmlFor="email">Email:</label>
						<input
							name="email"
							type="email"
							value={email}
							onChange={e => setEmail(e.target.value)}
							id="email"
							required
						></input>
						<label htmlFor="password">Password:</label>
						<input
							name="password"
							type="password"
							value={password}
							onChange={e => setPassword(e.target.value)}
							id="password"
							required
						></input>
						<button type="submit">Sign In</button>
						
						<span id="errorMessage" style={{color: 'red', minWidth: '200px', minHeight: '50px' }}>{errorMessage}</span>
					</form>
				</section>
			</main>
		</>
	);
}
